<template>
  <el-dialog :title="$t('edit_leave')" :close-on-click-modal="false" :visible.sync="visible" append-to-body>
    <el-form
      :model="dataForm"
      :rules="dataRule"
      ref="dataForm"
      :label-width="$store.state.settings.curLang.key === 'en' ? '200px' : '140px'"
    >
      <!-- 员工姓名 -->
      <el-form-item :label="`${$t('payroll_management_31')} :`">
        <span>{{ staff_name }}</span>
      </el-form-item>
      <!-- 员工属性 -->
      <el-form-item :label="`${$t('32')} :`">
        <span>{{ formal_name }}</span>
      </el-form-item>
      <!-- 离职日期 -->
      <el-form-item :label="$t('29')" prop="leave_date">
        <template #label>
          <span>{{ $t('29') }}</span>
          <el-tooltip class="item" effect="dark" :content="$t('i18n.7Y1RdNWcszSG')" placement="top-start">
            <i class="el-icon-warning-outline"></i>
          </el-tooltip>
        </template>
        <el-date-picker
          v-model="dataForm.leave_date"
          type="date"
          value-format="yyyy-MM-dd"
          :placeholder="$t('221')"
          clearable
          :picker-options="pickerOptions"
        >
        </el-date-picker>
      </el-form-item>
      <!-- 离职原因 -->
      <el-form-item :label="$t('leave_reason')" prop="reason">
        <el-select v-model="dataForm.reason" :placeholder="`   ${$t('221')}`" clearable>
          <el-option
            v-for="(item, index) in reasonArr"
            :key="index"
            :label="item.reason"
            :value="item.code"
          ></el-option>
        </el-select>
      </el-form-item>
      <!-- 离职原因备注 -->
      <el-form-item :label="$t('leave_reason_remarks')" prop="remark">
        <el-input
          v-model="dataForm.remark"
          :placeholder="$t('1256')"
          type="textarea"
          :autosize="{ minRows: 6, maxRows: 4 }"
          maxlength="200"
          show-word-limit
        ></el-input>
      </el-form-item>
      <el-form-item class="quit-manger-agree" prop="agree" v-if="isAutoLogOff">
        <el-checkbox v-model="dataForm.agree">{{ $t('17274_16b65457') }}</el-checkbox>
      </el-form-item>
    </el-form>
    <template slot="footer">
      <el-button @click="visible = false">{{ $t('66') }}</el-button>
      <el-button type="primary" plain @click="dataFormSubmit" :disabled="!dataForm.agree">
        {{ $t('131') }}
      </el-button>
    </template>
  </el-dialog>
</template>

<script>
import {
  isWaitAudit, // 判断当前员工是否有独自待审批节点任务
  getInit, // 离职原因,来源
  editResign // 编辑离职
} from '@/api/org/staff'

export default {
  data() {
    const self = this
    return {
      // 账号自动注销
      isAutoLogOff: false,
      visible: false,
      dataForm: {
        leave_date: '',
        reason: '',
        remark: '',
        agree: false
      },
      staff_name: '',
      staff_id: '',
      formal_name: '', // 员工属性
      hire_date: '', // 入职日期
      dataRule: {
        leave_date: [
          {
            required: true,
            message: this.$t('1014')
          }
        ],
        reason: [
          {
            required: true,
            message: this.$t('712')
          }
        ],
        remark: [
          {
            required: true,
            message: this.$t('1999')
          }
        ],
        agree: [
          {
            required: true,
            message: this.$t('17274_6b654577')
          }
        ]
      },
      pickerOptions: {
        // 自动注销账号最大可选择操作当天
        disabledDate(time) {
          if (self.isAutoLogOff) return time.getTime() < self.hire_date || time.getTime() > Date.now()
          return time.getTime() < self.hire_date
        }
      },
      reasonArr: [] // 离职原因
    }
  },
  methods: {
    init(item) {
      this.visible = true
      this.$nextTick(() => {
        this.$refs.dataForm.resetFields()
        this.staff_name = item.staff_name
        this.formal_name = item.formal_name
        this.dataForm.leave_date = item.leave_date
        this.dataForm.reason = parseInt(item.leave_reason)
        this.dataForm.remark = item.leave_reason_remarks
        this.dataForm.apply_source = item.apply_source
        const isAutoLogOff = item.apply_source === '4'
        this.isAutoLogOff = isAutoLogOff
        this.dataForm.agree = !isAutoLogOff
        this.staff_id = item.staff_id
        this.hire_date = new Date(item.hire_date).getTime()
      })
      getInit().then(res => {
        this.reasonArr = res.data.reason.reason
      })
    },
    async addResign() {
      await editResign({ ...this.dataForm, staff_id: this.staff_id })
      this.$emit('onSubmit')
      this.visible = false
    },
    // 编辑离职提交
    dataFormSubmit() {
      this.$refs.dataForm.validate(async valid => {
        if (valid) {
          // 如果所选“离职日期”为当日及以前，则该员工自动变为离职的同时，检查该员工当前是否有待审批任务，且该节点没有其他未离职的员工（在职/待离职/停职）
          const day = this.$util.parseTime(new Date(), '{y}-{m}-{d}')
          if (this.dataForm.leave_date <= day) {
            const { data } = await isWaitAudit({ staff_id: this.staff_id })
            if (data) {
              this.$confirm(this.$t('b2b876c0'), this.$t('229'), {
                confirmButtonText: this.$t('131'),
                cancelButtonText: this.$t('66'),
                type: 'warning'
              })
                .then(() => {
                  this.addResign()
                })
                .catch(() => {})
            } else {
              this.addResign()
            }
          } else {
            this.addResign()
          }
        }
      })
    }
  }
}
</script>

<style lang="scss">
.quit-manger-agree {
  .el-form-item__content {
    margin-left: 0 !important;
  }
}
</style>
